import { useContext } from 'react';
import { AsDataContext } from '../providers/AsDataProvider';
function useAsDataContext() {
    return useContext(AsDataContext);
}
export default useAsDataContext;
